// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2SSB3","bigColWidth":"Table_bigColWidth__2CR_U","biggerColWidth":"Table_biggerColWidth__1b4PC","row":"Table_row__3p-ow","col":"Table_col__o5LED"};